import React from 'react';
import styles from './Login.module.css';

/**
 * Split-panel shell shared by every unauthenticated screen: login,
 * password recovery and forced password change.
 *
 * The brand panel and the footer were duplicated verbatim in all three
 * before this existed — any copy edit had to be made three times, and
 * they had already drifted. Callers now supply only their form content.
 */
const AuthLayout = ({ children, loading = false }) => (
  <div className={styles.shell}>
    <aside className={styles.brand}>
      <div className={styles.brandInner}>
        <div className={styles.brandLogo}>
          <img src="/eCliniQ.png" alt="eCliniq" className={styles.brandLogoImg} />
          <span className={styles.brandLogoText}>
            <span className={styles.brandLogoE}>e</span>Cliniq
          </span>
        </div>

        <div className={styles.brandHeadline}>
          <h1>Gestión clínica<br />inteligente.</h1>
          <p>Todo lo que su clínica necesita, en un solo lugar.</p>
        </div>

        <ul className={styles.brandFeatures}>
          <li>
            <i className="fas fa-user-injured" />
            <span>Historias clínicas de pacientes centralizadas</span>
          </li>
          <li>
            <i className="fas fa-calendar-check" />
            <span>Agenda de citas y consultas en tiempo real</span>
          </li>
          <li>
            <i className="fas fa-shield-halved" />
            <span>Gestión de seguros médicos integrada</span>
          </li>
        </ul>
      </div>

      <div className={styles.brandPattern} aria-hidden="true" />
    </aside>

    <main className={styles.formPanel}>
      <div className={styles.formWrap}>{children}</div>

      <p className={styles.footer}>
        © {new Date().getFullYear()} eCliniq · Plataforma de gestión clínica
      </p>
    </main>

    {loading && (
      <div className={styles.overlay} aria-hidden="true">
        <div
          className="spinner-border"
          style={{ width: '2.5rem', height: '2.5rem', color: 'var(--ec-primary)' }}
        />
      </div>
    )}
  </div>
);

export default AuthLayout;
